import { render, staticRenderFns } from "./SearchDocumentSection.vue?vue&type=template&id=4745bcc6&scoped=true&"
import script from "./SearchDocumentSection.vue?vue&type=script&lang=js&"
export * from "./SearchDocumentSection.vue?vue&type=script&lang=js&"
import style0 from "./SearchDocumentSection.vue?vue&type=style&index=0&id=4745bcc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4745bcc6",
  null
  
)

export default component.exports